import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import FixedFilter from './Fixed'

const Filters = ({
  fixedFilters,
  onChange,
  fields,
  defaultValue,
  viewType,
  onFetchRemoteData,
  tbs,
  showSearch,
}) => {
  return (
    <div>
      <ErrorBoundary fallback={<div>筛选渲染错误</div>}>
        <FixedFilter
          className="fixed"
          tbs={tbs}
          // 固定筛选的字段
          fixedFilters={fixedFilters}
          onChange={onChange}
          onFetchRemoteData={onFetchRemoteData}
          // 所有的字段定义
          fields={fields}
          viewType={viewType}
          defaultValue={defaultValue}
          showSearch={showSearch}
        />
      </ErrorBoundary>
    </div>
  )
}

export default Filters
